export default {
  title: '製品属性',
  addFirstLevel: '属性グループ追加',
  addSecondLevel: '属性追加',
  attributeName: '属性名',
  addModal: '属性グループ追加',
  addSecondModal: '属性追加',
  editModal: '属性編集',
  required: '属性名を入力してください',
};
